import { useEffect, useMemo, useState } from "react";
import { normalizeEtaSeconds } from "../utils/progressEta";

export default function useEtaCountdown(etaSeconds, running) {
	const normalizedEta = useMemo(
		() => normalizeEtaSeconds(etaSeconds),
		[etaSeconds],
	);
	const [countdownSeconds, setCountdownSeconds] = useState(normalizedEta);

	useEffect(() => {
		setCountdownSeconds(normalizedEta);
	}, [normalizedEta]);

	useEffect(() => {
		if (!running || countdownSeconds == null) return undefined;
		const id = window.setInterval(() => {
			setCountdownSeconds((prev) => {
				if (prev == null) return prev;
				return Math.max(0, prev - 1);
			});
		}, 1000);
		return () => window.clearInterval(id);
	}, [running, countdownSeconds == null]);

	return countdownSeconds;
}
